import { z } from "zod";
import { idSchema, isoDateTimeSchema } from "./shared";

export const slackSettingsSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  enabled: z.boolean(),
  defaultChannelId: z.string().nullable(),
  signingSecretConfigured: z.boolean(),
  botTokenConfigured: z.boolean(),
  appTokenConfigured: z.boolean(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});

export const updateSlackSettingsRequestSchema = slackSettingsSchema.pick({
  enabled: true,
  defaultChannelId: true,
});

export const slackSettingsResponseSchema = z.object({
  settings: slackSettingsSchema,
  status: z.object({
    configured: z.boolean(),
    missingSecrets: z.array(z.string()),
    expectedScopes: z.array(z.string()),
    socketModeReady: z.boolean(),
  }),
});

export const githubSettingsSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  enabled: z.boolean(),
  organization: z.string().nullable(),
  appId: z.string().nullable(),
  clientId: z.string().nullable(),
  installationId: z.string().nullable(),
  appSlug: z.string().nullable(),
  repositorySelection: z.enum(["all", "selected"]).nullable(),
  syncedRepositoryCount: z.number(),
  secretsConfigured: z.boolean(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});

export const updateGithubSettingsRequestSchema = githubSettingsSchema.pick({
  enabled: true,
  organization: true,
  appId: true,
  clientId: true,
  installationId: true,
  appSlug: true,
  repositorySelection: true,
});

export const githubRepositorySchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  owner: z.string().min(1),
  name: z.string().min(1),
  defaultBranch: z.string().min(1),
});

export const githubPullRequestLinkSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  issueId: idSchema,
  agentRunId: idSchema.nullable(),
  repositoryId: idSchema,
  repository: z.string().min(1),
  url: z.string().url(),
  state: z.enum(["linked", "open", "closed", "merged"]),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});

export const githubSettingsResponseSchema = z.object({
  settings: githubSettingsSchema,
  repositories: z.array(githubRepositorySchema),
  status: z.object({
    configured: z.boolean(),
    missingSecrets: z.array(z.string()),
    expectedPermissions: z.array(z.string()),
    installAllRepositoriesRecommended: z.boolean(),
  }),
});

export const githubBranchSuggestionRequestSchema = z.object({
  issueKey: z.string().min(1),
  title: z.string().min(1),
});

export const githubBranchSuggestionResponseSchema = z.object({
  branchName: z.string().min(1),
});

export const linkGithubPullRequestRequestSchema = z.object({
  url: z.string().url(),
  repositoryId: idSchema.optional(),
  agentRunId: idSchema.optional(),
});
